import getDefaultShouldEventsEndEarly from './getDefaultShouldEventsEndEarly';
import getDefaultShouldShortenEventDuration from './getDefaultShouldShortenEventDuration';
import { isFeatureEnabled } from 'owa-feature-flags';
import { beginLightning } from 'owa-lightning-core-v2';
import { LightningId } from 'owa-lightning-v2';

/**
 * Lightup the speedy meetings - end early setting FRE or the shorten events duration setting FRE
 */
export default function lightupSpeedyMeetingsFRE(): void {
    if (!shouldLightupSpeedyMeetingsEndEarly() && !shouldLightupShortenEventsDuration()) {
        return;
    }

    const lightningId = isFeatureEnabled('cal-mf-shortenEventsDuration')
        ? LightningId.ShortenEventsDurationSetting
        : LightningId.SpeedyMeetingsEndEarlySetting;

    beginLightning(lightningId, triggerLightup);
}

function triggerLightup(lightup: () => void): void {
    lightup();
}

/**
 * Lightup speedy meetings - end early if:
 * - the feature is enabled and
 * - the dialog flight is enabled and
 * - the new feature is not enabled and
 * - the setting is not turned on
 */
function shouldLightupSpeedyMeetingsEndEarly(): boolean {
    return (
        isFeatureEnabled('cal-mf-shouldEventsEndEarlySetting') &&
        isFeatureEnabled('cal-mf-shouldEventsEndEarlyFREDialog') &&
        !isFeatureEnabled('cal-mf-shortenEventsDuration') &&
        !getDefaultShouldEventsEndEarly()
    );
}

/**
 * Lightup shorten events duration if:
 * - the feature is enabled and
 * - the setting is not turned on
 */
function shouldLightupShortenEventsDuration(): boolean {
    return (
        isFeatureEnabled('cal-mf-shortenEventsDuration') && !getDefaultShouldShortenEventDuration()
    );
}
